import { alpha } from '@mui/material';
/**
 * MuiBackdrop
 */
const MuiBackdrop = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&:not(.MuiBackdrop-invisible)': {
        backgroundColor: alpha(theme.palette.primary.dark, 0.9)
      }
    })
  }
};
export default MuiBackdrop;